// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
table[data-v-7e8cab53] {
  width: 100%;
  border-collapse: collapse;
}
th[data-v-7e8cab53],
td[data-v-7e8cab53] {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}
td[data-v-7e8cab53] {
  position: relative;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
